import { ACCOUNTS, BROWSING_REWARDS_STATISTICS } from 'resources/endpoints'
import convertKeys from 'utils/convert-keys'
import axiosInstance, { cognitoAxiosInstance } from 'config/axiosInstance'
import { getToken } from 'services/amplify/auth'

const updateAccount = async (userId, data) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).patch(`${ACCOUNTS}/${userId}/`, {
    ...data,
  })
  return convertKeys.toCamel(response.data)
}

const fetchProfileInfo = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(`${ACCOUNTS}/me/`)
  return convertKeys.toCamel(response.data)
}

const fetchReferralData = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).get(`${ACCOUNTS}/me/referral`)
  return convertKeys.toCamel(response.data)
}

const setReklaimRewardsTag = async () => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/tag_reklaim_rewards`)
  return convertKeys.toCamel(response.data)
}

const addPhoneNumberSendSmsCode = async (phoneNumber) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/phone_number/add/send_sms_code/`, {
    phone_number: phoneNumber,
  })
  return convertKeys.toCamel(data)
}

const addPhoneNumberVerifySmsCode = async (phoneNumber, code) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/phone_number/add/verify_sms_code/`, {
    phone_number: phoneNumber,
    code,
  })
  return convertKeys.toCamel(data)
}

const removePhoneNumber = async (phoneNumber) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/phone_number/remove/`, {
    phone_number: phoneNumber,
  })
  return convertKeys.toCamel(data)
}

const removeEmailAddress = async (emailAddress) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/email_address/remove/`, {
    email_address: emailAddress,
  })
  return convertKeys.toCamel(data)
}

const deleteAccount = async (userId) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).delete(`${ACCOUNTS}/${userId}/`)
  return convertKeys.toCamel(response.data)
}

const addEmailAddressSendVerificationEmail = async (emailAddress, source = null) => {
  const token = await getToken()
  const response = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/email_address/add/send_verification/`, {
    email_address: emailAddress,
    source,
  })
  return convertKeys.toCamel(response.data)
}

const addEmailAddressVerifyToken = async (token) => {
  const { data } = await axiosInstance.post(`${ACCOUNTS}/me/email_address/add/verify_token/`, {
    token,
  })

  return convertKeys.toCamel(data)
}

const upsertIpAddress = async (ipAddress, country, countryRegion) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).put(`${ACCOUNTS}/me/ip_address/`, {
    ip_address: ipAddress,
    country,
    country_region: countryRegion,
  })
  return convertKeys.toCamel(data)
}

const fetchBrowsingRewardsStatistics = async () => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).get(BROWSING_REWARDS_STATISTICS)
  return convertKeys.toCamel(data)
}

const setPrimaryEmailAddress = async (emailAddress) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/email_address/set_primary/`, {
    email_address: emailAddress,
  })
  return convertKeys.toCamel(data)
}

const setPrimaryPhoneNumber = async (phoneNumber) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/phone_number/set_primary/`, {
    phone_number: phoneNumber,
  })
  return convertKeys.toCamel(data)
}

const setUserHandle = async (userHandle) => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/user_handle/`, { user_handle: userHandle })
  return convertKeys.toCamel(data)
}

const uploadProfilePicture = async (profilePictureBlob, fileName) => {
  const token = await getToken()

  const formData = new FormData()
  formData.append('profile_picture', profilePictureBlob, fileName)

  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/profile_picture/`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return convertKeys.toCamel(data)
}

const setIsUnveilOnboarded = async () => {
  const token = await getToken()
  const { data } = await cognitoAxiosInstance(token).post(`${ACCOUNTS}/me/complete_onboarding/`)
  return convertKeys.toCamel(data)
}

export default {
  updateAccount,
  fetchProfileInfo,
  fetchReferralData,
  setReklaimRewardsTag,
  addPhoneNumberSendSmsCode,
  addPhoneNumberVerifySmsCode,
  removePhoneNumber,
  removeEmailAddress,
  deleteAccount,
  addEmailAddressSendVerificationEmail,
  addEmailAddressVerifyToken,
  upsertIpAddress,
  fetchBrowsingRewardsStatistics,
  setPrimaryEmailAddress,
  setPrimaryPhoneNumber,
  setUserHandle,
  uploadProfilePicture,
  setIsUnveilOnboarded,
}
